<template>
    <el-container class="detail-page">
        <el-header>
            <div>
                <el-button @click.native.prevent="goBack" class="el-icon-arrow-left"
                           :aria-label="$t('common.back')"></el-button>
                {{$t('itemCreate.pageTitle')}}
            </div>
            <div>
                <el-button @click.native.prevent="createItem" type="success" :disabled="buttonDisabledStatus">{{$t('common.save')}}
                </el-button>
            </div>
        </el-header>
        <el-main v-loading="loading">
            <el-alert v-if="loadError !== ''" :title="loadError" type="error" :closable="false" show-icon></el-alert>
            <el-form v-else-if="contextLoaded" class="item-edit-form" label-width="120px" :model="objectModel" ref="objectModel">

                <div class="item-card-grid">
                    <el-card class="item-info-card">
                        <el-row>
                            <el-col :span="16" class="biaoti">
                                <div class="grid-content bg-purple">
                                    <span>{{$t('itemCreate.itemTitle')}}</span>
                                </div>
                            </el-col>
                        </el-row>
                        <el-divider></el-divider>

                        <div class="item-fields-column">
                            <div v-if="userSetting.isShowProduceCode === 1">
                                <el-form-item :label="userSetting.codeLabel">
                                    <el-input type="textarea" :autosize="{minRows: 1}" :placeholder="userSetting.codeLabel"
                                              v-model="objectModel.itemCode"></el-input>
                                </el-form-item>
                            </div>

                            <el-form-item :label="$t('common.description')">
                                <el-input type="textarea" :autosize="{minRows: 1}" :placeholder="$t('common.description')"
                                          v-model="objectModel.itemDescription"></el-input>
                            </el-form-item>

                            <el-form-item :label="userSetting.rateLabel">
                                <div class="signed-number-field">
                                    <div class="inventory-adjust-control" :aria-label="$t('itemCreate.rateSign')">
                                        <button :class="['inventory-adjust-button', 'increase', rateSign === 1 ? 'active' : '']" type="button" @click="setRateSign(1)">+</button>
                                        <button :class="['inventory-adjust-button', 'decrease', rateSign === -1 ? 'active' : '']" type="button" @click="setRateSign(-1)">-</button>
                                    </div>
                                    <el-input inputmode="decimal" onfocus="this.select()" v-model="objectModel.rate"></el-input>
                                </div>
                            </el-form-item>
                            <el-form-item :label="$t('itemCreate.labelCost')" class="cost-option-row">
                                <el-switch v-model="objectModel.isShowCost" :active-value="1" :inactive-value="0"></el-switch>
                                <el-input v-if="objectModel.isShowCost === 1" class="cost-number-input" inputmode="decimal" onfocus="this.select()" v-model="objectModel.cost"></el-input>
                            </el-form-item>
                            <el-form-item :label="$t('itemCreate.labelUnit')">
                                <div class="unit-field">
                                    <el-input :placeholder="$t('itemCreate.placeholderUnit')" v-model="objectModel.unit"></el-input>
                                    <div class="unit-tag-list" v-if="unitOptionList.length > 0">
                                        <el-tag
                                                v-for="unit in unitOptionList"
                                                :key="unit"
                                                class="unit-tag"
                                                type="info"
                                                @click.native="selectUnit(unit)">
                                            {{unit}}
                                        </el-tag>
                                    </div>
                                </div>
                            </el-form-item>
                        </div>

                    </el-card>

                    <el-card class="default-taxes-card">
                        <el-row>
                            <el-col :span="16" class="biaoti">
                                <div class="grid-content bg-purple">
                                    <span>{{$t('itemCreate.defaultTaxes')}}</span>
                                </div>
                            </el-col>
                        </el-row>
                        <el-divider></el-divider>

                        <el-form-item v-for="(taxInfo , i ) in taxList" :key="taxInfo.innerUUID" :label="taxInfo.taxName">
                            <el-radio-group v-model="chooseTaxList[i]">
                                <el-radio v-for="rate in taxInfo.rateList" :key="taxInfo.innerUUID + '-' + rate" :label="rate">{{parseFloat((rate*
                                    100).toFixed(4)) + "%"}}
                                </el-radio>
                                <el-radio label=-1>{{$t('itemCreate.taxOff')}}</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-card>

                    <el-card class="inventory-side-card">
                        <div class="inventory-card-header">
                            <span class="inventory-side-title">{{$t('itemCreate.inventoryTitle')}}</span>
                            <el-switch v-model="objectModel.isShowInventory" :active-value=1 :inactive-value=0 @change="changeInventoryStatus"></el-switch>
                        </div>
                        <el-divider></el-divider>
                        <div v-if="objectModel.isShowInventory === 1" class="inventory-panel">
                            <div class="inventory-total">
                                <span>{{$t('itemCreate.currentInventory')}}</span>
                                <strong>{{inventoryTotal}}</strong>
                            </div>
                            <div class="inventory-adjust-box">
                                <div class="inventory-adjust-title">{{$t('itemCreate.adjustInventory')}}</div>
                                <div class="inventory-form">
                                    <div class="inventory-first-row">
                                        <div class="inventory-adjust-control" :aria-label="$t('itemCreate.inventorySign')">
                                            <button :class="['inventory-adjust-button', 'increase', inventoryAdjustType === 1 ? 'active' : '']" type="button" @click="setInventoryAdjustType(1)">+</button>
                                            <button :class="['inventory-adjust-button', 'decrease', inventoryAdjustType === -1 ? 'active' : '']" type="button" @click="setInventoryAdjustType(-1)">-</button>
                                        </div>
                                        <el-input class="inventory-number-input" inputmode="decimal" :placeholder="$t('itemCreate.placeholderQuantity')" onfocus="this.select()" v-model="inventoryForm.inventoryNumber"></el-input>
                                        <el-date-picker
                                                class="inventory-date-input"
                                                v-model="inventoryForm.inventoryDate"
                                                type="datetime"
                                                format="yyyy-MM-dd HH:mm"
                                                :placeholder="$t('itemCreate.placeholderDateAndTime')">
                                        </el-date-picker>
                                    </div>
                                    <div class="inventory-note-row">
                                        <el-input class="inventory-note-input" type="textarea" :autosize="{minRows: 2}" :placeholder="$t('itemCreate.placeholderNote')" v-model="inventoryForm.note"></el-input>
                                        <el-button class="inventory-add-button" type="primary" :loading="inventorySaveLoading" @click="addInventory">{{$t('itemCreate.addButton')}}</el-button>
                                    </div>
                                </div>
                            </div>
                            <el-table class="inventory-table" :data="inventoryList" max-height="528">
                                <el-table-column prop="inventoryDate" :label="$t('itemCreate.columnDate')" :formatter="formatInventoryDate" min-width="160" class-name="inventory-date-column"></el-table-column>
                                <el-table-column prop="inventoryNumber" :label="$t('itemCreate.columnQuantity')"></el-table-column>
                                <el-table-column prop="note" :label="$t('itemCreate.columnNote')">
                                    <template slot-scope="scope">
                                        <span class="inventory-note-cell">{{scope.row.note}}</span>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </el-card>

                    <el-card v-if="userSetting.withHoldingActive === 1" class="withholding-card">
                        <div class="card-title-row">
                            <span>{{$t('itemCreate.withholdingTitle')}}</span>
                            <el-switch v-model="itemWithHoldingActive" :active-value=1 :inactive-value=0></el-switch>
                        </div>
                        <el-divider></el-divider>
                        <div class="withholding-value-row">{{userSetting.withHoldingTaxName}}({{userSetting.withHoldingTaxRate}}%)</div>
                    </el-card>
                </div>

            </el-form>
        </el-main>
    </el-container>
</template>

<script>
    import {uuid, timest, toTmpTime} from '@/utils/validate'
    import {formatLocalizedDateTime} from '@/utils/time'
    import {isValidItemDecimal, isValidItemUnit, itemDecimalSign, setItemDecimalSign} from '@/utils/itemInputValidation'
    import {syncCompanySelection} from '@/utils/company'

    export default {
        data() {
            return {
                objectModel: {
                    itemDescription: '',
                    rate: 0,
                    cost: 0,
                    itemCode: "",
                    unit: "",
                    isShowCost: 0,
                    isShowInventory: 0
                },
                itemInnerUUID: uuid(null, 37),
                chooseTaxList: [],
                taxList: [],
                taxListLoaded: false,
                taxListLoadPromise: null,
                loading: true,
                loadError: '',
                contextLoaded: false,
                buttonDisabledStatus: true,
                userSetting: null,
                userCompany: null,
                itemWithHoldingActive: 1,
                unitOptionList: [],
                inventoryList: [],
                inventoryForm: {
                    inventoryNumber: "",
                    note: "",
                    inventoryDate: null
                },
                inventoryAdjustType: 1,
                inventorySaveLoading: false
            };
        },
        computed: {
            rateSign() {
                return itemDecimalSign(this.objectModel.rate);
            },
            inventoryTotal() {
                return this.inventoryList.reduce((total, inventory) => {
                    return this.$NP.plus(total, Number(inventory.inventoryNumber));
                }, 0);
            }
        },
        methods: {
            goBack() {
                let self = this;
                self.$router.push('/item');
            },
            //查询taxInfo列表
            queryUserTaxInfoList() {
                if (this.taxListLoaded) {
                    return Promise.resolve();
                }
                if (this.taxListLoadPromise !== null) {
                    return this.taxListLoadPromise;
                }
                this.taxListLoadPromise = this.$axios.post('query_tax_info_list_user_web', {
                    params: {
                        "currentPage": 1,
                        "pageSize": 99999999,
                        "delStatus": 0,
                        "invoiceTaxOrNot": 1,
                        "companyUUID": this.userCompany.innerUUID
                    }
                }).then(response => {
                    if (response.data.errorCode !== 0) {
                        throw new Error(response.data.errorMsg);
                    }
                    let responseRateList = Array.isArray(response.data.dataList) ? response.data.dataList : [];
                    //因为有的税是被删除的,所以要单独弄个角标记录默认选中的值
                    for (let i = 0; i < responseRateList.length; i++) {
                        let rateItem = responseRateList[i];
                        // rateItem  =  0.1&&0.16
                        let rateSplit = String(rateItem.rates == null ? '' : rateItem.rates)
                            .split("&&").filter(rate => rate !== '');
                        rateItem.rateList = rateSplit;
                        this.taxList.push(rateItem);
                        //默认选中第一个值,这个是真正选中的数据model
                        this.chooseTaxList[i] = rateSplit[0];
                    }
                    this.taxListLoaded = true;
                }).finally(() => {
                    this.taxListLoadPromise = null;
                });
                return this.taxListLoadPromise;
            },
            loadUnitOptions() {
                this.unitOptionList = [];
                if (this.userCompany.unitSet == null || this.userCompany.unitSet === "") {
                    return;
                }
                this.unitOptionList = this.userCompany.unitSet.split("&&").filter(unit => unit !== "");
            },
            selectUnit(unit) {
                this.objectModel.unit = unit;
            },
            setRateSign(sign) {
                this.objectModel.rate = setItemDecimalSign(this.objectModel.rate, sign);
            },
            saveUnitSetIfNeeded() {
                let unit = String(this.objectModel.unit == null ? '' : this.objectModel.unit).trim();
                if (unit === "") {
                    return Promise.resolve();
                }
                if (this.unitOptionList.indexOf(unit) !== -1) {
                    return Promise.resolve();
                }
                let newUnitSet = this.unitOptionList.concat([unit]).join("&&");
                return this.$axios.post('update_company', {
                    params: {
                        innerUUID: this.userCompany.innerUUID,
                        unitSet: newUnitSet,
                        accessDate: timest()
                    }
                }).then(response => {
                    if (response.data.errorCode !== 0) {
                        throw new Error('Company unit save failed');
                    }
                    this.userCompany.unitSet = newUnitSet;
                    localStorage.setItem('userCompany', JSON.stringify(this.userCompany));
                    this.unitOptionList.push(unit);
                })
            },
            buildInventoryRequest(inventoryItem) {
                return {
                    innerUUID: inventoryItem.innerUUID,
                    companyUUID: this.userCompany.innerUUID,
                    syncStatus: 0,
                    note: inventoryItem.note,
                    inventoryDate: inventoryItem.inventoryDate,
                    inventoryNumber: inventoryItem.inventoryNumber,
                    relatedItemUUID: this.itemInnerUUID,
                    belongItemUUID: this.itemInnerUUID,
                    fromClient: 3,
                    accessDate: inventoryItem.accessDate,
                    createDate: inventoryItem.createDate
                };
            },
            changeInventoryStatus(value) {
                if (value === 0) {
                    this.objectModel.isShowInventory = 1;
                    this.$message.warning(this.$t('itemCreate.msgInventoryCannotDisable'));
                }
            },
            setInventoryAdjustType(type) {
                this.inventoryAdjustType = type;
            },
            addInventory() {
                if (this.inventoryForm.inventoryNumber === "") {
                    this.$message.error(this.$t('itemCreate.msgQuantityRequired'));
                    return;
                }
                if (!isValidItemDecimal(this.inventoryForm.inventoryNumber, false, 5)) {
                    this.$message.error(this.$t('itemCreate.msgInvalidInventory'));
                    return;
                }
                if (this.inventoryForm.inventoryDate === null || this.inventoryForm.inventoryDate === "") {
                    this.$message.error(this.$t('itemCreate.msgDateRequired'));
                    return;
                }
                let inventoryNumber = this.inventoryForm.inventoryNumber.trim();
                if (this.inventoryAdjustType === -1 && parseFloat(inventoryNumber) !== 0) {
                    inventoryNumber = "-" + inventoryNumber;
                }
                let inventoryNote = this.inventoryForm.note.trim();
                if (inventoryNote === '') {
                    inventoryNote = this.inventoryAdjustType === 1
                        ? this.$t('itemCreate.increase')
                        : this.$t('itemCreate.decrease');
                }
                let inventoryItem = {
                    innerUUID: uuid(null, 37),
                    companyUUID: this.userCompany.innerUUID,
                    syncStatus: 0,
                    note: inventoryNote,
                    inventoryDate: toTmpTime(this.inventoryForm.inventoryDate),
                    inventoryNumber: inventoryNumber,
                    relatedItemUUID: "",
                    belongItemUUID: this.itemInnerUUID,
                    fromClient: 3,
                    accessDate: timest(),
                    createDate: timest()
                };
                this.inventoryList.push(inventoryItem);
                this.inventoryForm.inventoryNumber = "";
                this.inventoryForm.note = "";
                this.inventoryForm.inventoryDate = null;
            },
            saveInventoryList() {
                let inventoryRequestList = [];
                for (let i = 0; i < this.inventoryList.length; i++) {
                    inventoryRequestList.push(this.$axios.post('create_item_inventory', {
                        params: this.buildInventoryRequest(this.inventoryList[i])
                    }));
                }
                return Promise.all(inventoryRequestList);
            },
            formatInventoryDate(row, column) {
                let timestamp = Number(row[column.property] == null ? 0 : row[column.property]) * 1000;
                return formatLocalizedDateTime(timestamp, this.$i18n.locale);
            },
            async createItem() {
                if (!this.contextLoaded || this.loading || this.buttonDisabledStatus || this.userCompany == null) {
                    return;
                }
                let self = this;
                if (!isValidItemDecimal(this.objectModel.rate, true, 4)) {
                    this.$message.error(this.$t('itemCreate.msgInvalidRate'));
                    return;
                }
                if (!isValidItemDecimal(this.objectModel.cost, false, 5)) {
                    this.$message.error(this.$t('itemCreate.msgInvalidCost'));
                    return;
                }
                if (!isValidItemUnit(this.objectModel.unit)) {
                    this.$message.error(this.$t('itemCreate.msgInvalidUnit'));
                    return;
                }
                this.objectModel.unit = String(this.objectModel.unit == null ? '' : this.objectModel.unit).trim();
                this.buttonDisabledStatus = true;

                try {
                    await this.queryUserTaxInfoList();
                    //需要把税拼接后放到数据库中
                    let itemTaxString = "";
                    for (let i = 0; i < this.chooseTaxList.length; i++) {
                        itemTaxString = itemTaxString + this.taxList[i].innerUUID + ":" + this.chooseTaxList[i] + "&&";
                    }
                    itemTaxString = itemTaxString.substr(0, itemTaxString.length - 2);

                    //数据库保存的是,打开状态,并且item里面关闭才置为0,否则都是1
                    let withholdingAble = 1;
                    if (this.userSetting.withHoldingActive === 1 && this.itemWithHoldingActive === 0) {
                        withholdingAble = 0;
                    }
                    await this.saveUnitSetIfNeeded();
                    let createItemParams = {
                        itemCode: this.objectModel.itemCode,
                        companyUUID: this.userCompany.innerUUID,
                        fromClient: 3,
                        itemDescription: this.objectModel.itemDescription,
                        rate: this.objectModel.rate,
                        cost: this.objectModel.cost,
                        unit: this.objectModel.unit,
                        isShowInventory: this.objectModel.isShowInventory,
                        isShowCost: this.objectModel.isShowCost,
                        createdFromTime: 0,
                        timeUUID: "",
                        invoiceUUID: "",
                        discount: 0,
                        discountAsPercent: 0,
                        quantity: 0,
                        sortTag: 0,
                        syncStatus: 0,
                        type: 0,
                        belongToInvoice: 0,
                        allExclusiveTaxMoney: 0,
                        allInclusiveTaxMoney: 0,
                        subtotalMoney: 0,
                        taxType: 0,
                        totalMoney: 0,
                        withholdingMoney: 0,
                        allTaxMoney: 0,
                        taxRateInfo: itemTaxString,
                        withholdingAble: withholdingAble,
                        inventoryNumber: this.objectModel.isShowInventory === 1 ? this.inventoryTotal : 0,
                        innerUUID: this.itemInnerUUID,
                        createDate: timest(),
                        accessDate: timest(),
                        parentUUID: ""
                    };
                    let response = await this.$axios.post('create_item', {
                        params: createItemParams
                    });
                    if (response.data.errorCode !== 0) {
                        throw new Error('Item save failed');
                    }
                    if (this.objectModel.isShowInventory === 1 && this.inventoryList.length > 0) {
                        await this.saveInventoryList();
                    }
                    self.$router.push('/item');
                } catch {
                    this.$message.error(this.$t('common.saveFailed'));
                } finally {
                    this.loading = false;
                    this.buttonDisabledStatus = false;
                }
            },
            async loadPage() {
                this.loading = true;
                this.contextLoaded = false;
                this.buttonDisabledStatus = true;
                this.loadError = '';
                try {
                    const response = await this.$axios.post('query_setting_and_company', {params: {}});
                    if (response.data.errorCode !== 0) {
                        throw new Error('Company and setting query failed');
                    }
                    const selectedData = syncCompanySelection(response.data);
                    if (selectedData == null) {
                        throw new Error('Selected company data is missing');
                    }
                    this.userCompany = selectedData.company;
                    this.userSetting = JSON.parse(JSON.stringify(selectedData.setting));
                    this.userSetting.withHoldingTaxRate = parseFloat(this.userSetting.withHoldingTaxRate * 100).toFixed(4);
                    this.itemWithHoldingActive = this.userSetting.withHoldingActive;
                    this.loadUnitOptions();
                    await this.queryUserTaxInfoList();
                    this.contextLoaded = true;
                    this.buttonDisabledStatus = false;
                } catch {
                    this.loadError = this.$t('common.loadFailed');
                } finally {
                    this.loading = false;
                }
            }
        },
        mounted() {
            this.loadPage();
        }
    }
</script>
<style scoped>
    /deep/ .el-header {
        background-color: #f7f7f9;
        font-size: 25px;
        padding: 30px;
        font-weight: 600;
        height: 100px !important;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    /deep/ .el-input__inner {
        width: 50%;
        margin-left: 2%;
        border-style: none none solid none;
        border-radius: 0px;
    }

    /deep/ .el-textarea__inner {
        width: 50%;
        margin-left: 2%;
        border-style: none none solid none;
        border-radius: 0px;
    }

    /*去掉textarea右下角样式*/
    /deep/ .el-textarea__inner {
        resize: none;
    }

    .itemTitle {
        background: rgba(54, 60, 68, 0.05);
        padding-top: 10px;
        padding-bottom: 10px;
        padding-left: 3%;
        font-size: 18px;
        width: 55%;
    }

    /deep/ .biaoti {
        font-size: 24px;
        padding-left: 1%;
    }

    /deep/ .el-switch {
        margin-left: 6%;
    }

    .item-edit-form >>> .el-form-item__label {
        position: relative;
        left: 1%;
        text-align: left;
    }

    .item-card-grid {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        align-items: stretch;
        gap: 24px;
    }

    .item-info-card,
    .default-taxes-card,
    .inventory-side-card,
    .withholding-card {
        min-width: 0;
    }

    .item-fields-column {
        width: 100%;
    }

    .item-fields-column >>> .el-input__inner,
    .item-fields-column >>> .el-textarea__inner {
        width: 82%;
    }

    .signed-number-field {
        display: flex;
        align-items: center;
        gap: 12px;
        width: 82%;
        margin-left: 2%;
    }

    .signed-number-field >>> .el-input {
        flex: 1 1 auto;
    }

    .signed-number-field >>> .el-input__inner {
        width: 100%;
        margin-left: 0;
    }

    .cost-option-row >>> .el-form-item__content {
        display: flex;
        align-items: center;
        gap: 14px;
    }

    .cost-option-row >>> .el-switch {
        flex: 0 0 auto;
        margin-left: 2%;
    }

    .cost-number-input {
        flex: 1 1 auto;
        max-width: calc(82% - 54px);
    }

    .cost-number-input >>> .el-input__inner {
        width: 100%;
        margin-left: 0;
    }

    .inventory-side-card {
        border: 1px solid #E6E8EF;
        border-radius: 8px;
        background: #FFFFFF;
        box-shadow: 0 4px 14px rgba(31, 42, 68, 0.06);
    }

    .inventory-side-card >>> .el-card__body {
        padding: 22px 24px;
    }

    .inventory-side-title {
        color: #303133;
        font-size: 24px;
        line-height: 30px;
    }

    .inventory-card-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
    }

    .card-title-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        color: #303133;
        font-size: 24px;
        line-height: 30px;
    }

    .card-title-row >>> .el-switch {
        margin-left: 0;
    }

    .withholding-value-row {
        color: #606266;
        font-size: 16px;
        line-height: 34px;
    }

    .inventory-side-card >>> .el-divider--horizontal {
        margin: 20px 0 18px;
    }

    .inventory-card-header >>> .el-switch {
        margin-left: 0;
    }

    .unit-field {
        width: 82%;
        margin-left: 2%;
    }

    .unit-field >>> .el-input__inner {
        width: 100%;
        margin-left: 0;
    }

    .unit-tag-list {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        margin-top: 10px;
    }

    .unit-tag {
        cursor: pointer;
    }

    .inventory-panel {
        margin-top: 6px;
    }

    .inventory-total {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        margin-bottom: 16px;
        color: #303133;
        font-size: 16px;
    }

    .inventory-total strong {
        font-size: 22px;
    }

    .inventory-adjust-box {
        margin-bottom: 18px;
        padding: 16px;
        border: 1px solid #E6E8EF;
        border-radius: 8px;
        background: #F8FAFD;
    }

    .inventory-adjust-title {
        margin-bottom: 12px;
        color: #303133;
        font-size: 15px;
        font-weight: 500;
    }

    .inventory-form {
        display: flex;
        flex-direction: column;
        gap: 12px;
        width: 100%;
        margin-bottom: 0;
    }

    .inventory-first-row,
    .inventory-note-row {
        display: flex;
        align-items: flex-end;
        gap: 12px;
        width: 100%;
    }

    .inventory-adjust-control {
        display: flex;
        flex: 0 0 auto;
        overflow: hidden;
        border: 1px solid #DADDE6;
        border-radius: 8px;
        background: #FFFFFF;
    }

    .inventory-adjust-button {
        width: 40px;
        height: 34px;
        color: #606266;
        font-size: 20px;
        line-height: 30px;
        background: #FFFFFF;
        border: 0;
        cursor: pointer;
    }

    .inventory-adjust-button + .inventory-adjust-button {
        border-left: 1px solid #DADDE6;
    }

    .inventory-adjust-button.increase.active {
        color: #FFFFFF;
        background: #2DBE60;
    }

    .inventory-adjust-button.decrease.active {
        color: #FFFFFF;
        background: #F56C6C;
    }

    .inventory-number-input {
        width: 120px;
    }

    .inventory-number-input >>> .el-input__inner,
    .inventory-date-input >>> .el-input__inner {
        width: 100%;
        margin-left: 0;
    }

    .inventory-date-input {
        width: 190px;
    }

    .inventory-note-input {
        flex: 1 1 auto;
        min-width: 0;
    }

    .inventory-note-input >>> .el-textarea__inner {
        width: 100%;
        margin-left: 0;
    }

    .inventory-add-button {
        flex: 0 0 auto;
        min-width: 88px;
    }

    .inventory-table {
        width: 100%;
    }

    .inventory-table >>> .inventory-date-column .cell {
        white-space: pre;
    }

    .inventory-note-cell {
        display: -webkit-box;
        max-height: 44px;
        overflow: hidden;
        line-height: 22px;
        word-break: break-word;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
    }

    @media (max-width: 900px) {
        .item-card-grid {
            grid-template-columns: minmax(0, 1fr);
        }
    }

    @media (max-width: 640px) {
        /deep/ .el-header {
            height: 86px !important;
            padding: 20px 72px 20px 16px;
            font-size: 23px;
        }

        /deep/ .el-main {
            padding: 12px;
        }

        .item-edit-form >>> .el-form-item__label {
            float: none;
            width: 100% !important;
            padding-right: 0;
            line-height: 26px;
        }

        .item-edit-form >>> .el-form-item__content {
            margin-left: 0 !important;
        }

        .item-fields-column >>> .el-input__inner,
        .item-fields-column >>> .el-textarea__inner,
        .signed-number-field,
        .unit-field {
            width: 100%;
            margin-left: 0;
        }

        .cost-option-row >>> .el-switch {
            margin-left: 0;
        }

        .cost-number-input {
            max-width: none;
        }

        .inventory-side-card >>> .el-card__body {
            padding: 20px;
        }

        .inventory-first-row {
            align-items: stretch;
            flex-wrap: wrap;
        }

        .inventory-number-input {
            flex: 1 1 120px;
            width: auto;
        }

        .inventory-date-input {
            width: 100%;
        }

        .inventory-note-row {
            align-items: stretch;
            flex-direction: column;
        }

        .inventory-add-button {
            align-self: flex-end;
        }
    }
</style>

<style>
    .el-button--success {
        background-color: #0D7DF7;
        border-color: #0D7DF7;
    }

    .el-button--success:focus, .el-button--success:hover {
        background-color: #0D7DF7;
        border-color: #0D7DF7;
    }
</style>
